export default {
    meta: {
        title: '经营数据',
        isShowNav: true,
    },
};
